<template>
  <div class>
    <!-- 상단 고정 캠페인 배너 -->
    <!-- <div v-if="campaignData && campaignData.dynamicLink && campaignData.locationValue === null">
      <a :href="campaignData.dynamicLink.shortLink" target="_blank">
        <img :src="campaignData.image" :alt="campaignData.dynamicLink.name" />
      </a>
    </div> -->

    <NoDataHelpDesk v-if="isNoData"></NoDataHelpDesk>
    <!-- <div class="pdl-16 pdr-16 pdb-20"> -->
    <div id="tab1" class="t-color-content1 pdt-16 pdb-20">
      <div
        v-for="(faq, i) in listData"
        :key="i"
        class="pdl-16 pdr-16 pdt-16px pdb-16px"
        @click.prevent="faqDetail(faq.id)"
      >
        <div
          class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default"
        >
          <!-- <div>
              <button
                class="t-helper t-color-white bg-dark d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 mgr-4 b-radius2 l-spacing36 font-r"
              >계정 관리</button>
              <button
                class="t-helper t-color-white bg-blue1 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36 font-r"
              >로그인 또는 로그아웃</button>
          </div>-->
          <div
            class="t-subtitle3 t-color-title l-spacing48 pdt-10 pdb-8 font-m"
            v-if="
              faq &&
              faq.contents &&
              faq.contents.subject &&
              faq.contents.subject.length < 52
            "
          >
            {{ faq && faq.contents ? faq.contents.subject : "" }}
          </div>
          <div
            v-else
            class="t-subtitle3 t-color-title l-spacing48 pdt-10 pdb-8 font-m"
          >
            {{
              faq && faq.contents
                ? faq.contents.subject.substring(0, 50) + "..."
                : ""
            }}
          </div>
          <div
            v-if="
              faq &&
              faq.contents &&
              faq.contents.body &&
              faq.contents.body.length < 55
            "
            class="t-body3 t-color-content1 l-spacing42 font-r"
            v-html="faq.contents.body"
          ></div>
          <div
            v-else
            class="t-body3 t-color-content1 l-spacing42 font-r"
            v-html="jsonMethod(faq.contents.body)"
          ></div>

          <div class="pdt-20">
            <button
              v-if="
                faq &&
                faq.contents &&
                faq.contents.images &&
                faq.contents.images.length
              "
              class="t-helper t-color-blue3 bg-gray d-flex align-items-center pdt-5 pdb-5 pdl-4 pdr-4 b-radius2 mgb-4 font-r font-11"
            >
              <i class="material-icons font-16 pdr-8">attach_file</i>
              {{ $t("1765", { str: faq.contents.images.length }) }}
            </button>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <infinite-loading
        @infinite="fetchData"
        :identifier="infiniteId"
        spinner="spiral"
      >
        <div slot="no-more" class="mgt-16">No more data</div>
        <div slot="no-results" class="mgt-16"></div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import helpdeskApi from "@/api/helpdeskApi.js";
import campaignApi from "@/api/campaignApi.js";
import ListItem from "./ListItem.vue";
import NoDataHelpDesk from "../common/NoDataHelpDesk.vue";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    ListItem,
    NoDataHelpDesk,
    InfiniteLoading,

    Faq: () => import("@/components/helpDesk/Faq.vue"),
    Inqueriy: () => import("@/components/helpDesk/Inqueriy.vue"),
  },

  data() {
    return {
      status: "",
      isNoData: false,
      campaignData: null,
      listData: [],
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
    };
  },

  computed: {},

  watch: {
    $route(to, from) {
      this.initData();
    },
  },

  mounted() {
    // 기본 파라미터 설정(set default parameter)
    // if (!this.$route.query.status) {
    //     this.$router.push({query: {status: 'FAQ'}})
    // }
  },

  methods: {
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    // 목록 데이터 로딩(get list data)
    fetchData($state) {
      let responseData = null;
      let params = this.setParams();

      if (this.totalPages >= this.currentPage) {
        helpdeskApi
          .fetchList(params)
          .then((response) => {
            responseData = response.data.data;
            console.log("helpdeskList", responseData);
            _.map(responseData.content, (o) => {
              o.progressViewStatus = false;
            });
            this.listData = this.listData.concat(responseData.content);
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (responseData.content.length) {
              $state.loaded();
            } else {
              $state.complete();
            }

            console.log("nodata", this.listData.length);
            if (this.listData.length > 0) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
          })
          .catch((err) => {
            $state.error();
          });
      } else {
        $state.complete();
      }
    },
    jsonMethod(v) {
      let str = v.replace(/<a [^>]+>[^<]*<\/a>/, "");
      let strs = str.substring(0, 55) + "...";
      return strs; // create a "proxy" to the outer function
    },
    // 파라미터 설정(set parameter)
    setParams() {
      const params = {
        page: this.currentPage,
        size: 10,
        sort: "id,asc",
      };
      return params;
    },
    faqDetail(id) {
      this.$router.push("/faqdetail/" + id);
    },
    // 학습진행률 노출 상태 설정(set/toggle learning status graph)
    initProgressStatus(id) {
      _.map(this.listData, (o) => {
        o.id === id && o.progressViewStatus === false
          ? (o.progressViewStatus = true)
          : (o.progressViewStatus = false);
      });
    },
  },
};
</script>

<style scoped>
.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}

.tabs .indicator {
  background: #2d6dcc;
}

.mdc-elevation--z3 {
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.tabs .tab {
  width: 50%;
}
.listItems {
  border-bottom: 1px solid #e6eced;
}
.b-radius2 {
  border-radius: 2px;
}
.l-spacing36 {
  letter-spacing: -0.36px;
}
.font-16 {
  font-size: 16px;
}
.bg-blue3 {
  background-color: #80aed4;
}
.queryCount {
  border-radius: 50%;
}
.font-11 {
  font-size: 11px !important;
}
.ssss {
  display: none;
}
</style>